<div class="header">
  <h1>{{ statusMessage }}</h1>
  <mat-chip-list *ngIf="statusMessage">
    <mat-chip color="primary" selected class="count-chip">{{
      serviceProjectArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>
<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter Service Projects</mat-label>
        <input
          matInput
          (keyup)="filterServiceProjects($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      class="table"
      matSort
      fixedLayout="true"
    >
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let serviceProject">
          {{ serviceProject.customer || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="serviceProjectId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project ID</th>
        <td mat-cell *matCellDef="let serviceProject">
          {{ serviceProject.serviceProjectId || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
        <td mat-cell *matCellDef="let serviceProject">
          {{ serviceProject.createdDate | date : "shortDate" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
        <td mat-cell *matCellDef="let serviceProject">
          {{ serviceProject.createdBy || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="projectTypeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Type</th>
        <td mat-cell *matCellDef="let serviceProject">
          {{ serviceProject.projectTypeName || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="jobaddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
        <td mat-cell *matCellDef="let serviceProject">
          {{ serviceProject.jobaddress || "n/a" | titlecase }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No matching results
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="goToServiceProject(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
